import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAirport } from "../../api/apiAirports";
import parseError from "../../utils/parseError";

const useRestoreAirport = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAirportAction, isPending } = useMutation({
        mutationFn: restoreAirport,
        onSuccess: (res) => {
            const message = res?.message || "Airport restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore airport");
        },
    });

    return { restoreAirport: restoreAirportAction, isRestore: isPending };
};

export default useRestoreAirport;
